import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'prg-nav-container',
  templateUrl: './nav-container.html',
  styleUrls: [
    './nav-container.less'
  ]
})
export class NavContainerComponent implements OnInit {

  error: Observable<boolean>;
  ready: Observable<boolean>;

  constructor(
    protected store: Store<any>,
    protected router: Router,
    protected route: ActivatedRoute
  ) {
    this.error = this.store.select(s => s.sharedProgramming.error);
    this.ready = this.store.select(s => s.sharedProgramming.ready);

    this.ready.subscribe(ready => {
      // console.log('nav-container: ready changed', ready);
    });
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/nav-container/nav-container.ts